/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Sts_DetailInputs */



/**
* | output |
* | --- |
* | "Assessment of ship-to-ship (STS) transfer service providers against industry guidance. We review the provider's equipment, procedures and personnel to confir..." |
*
* @param {Service_Sts_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_sts_detail = /** @type {((inputs?: Service_Sts_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Sts_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("对照行业指南评估船对船（STS）过驳服务商。我们审查服务商的设备、程序和人员，确认过驳作业能够安全进行。")
	return /** @type {LocalizedString} */ ("Assessment of ship-to-ship (STS) transfer service providers against industry guidance. We review the provider's equipment, procedures and personnel to confirm that transfers can be carried out safely.")
});